<div class="address-validation-dialog">
  <div class="main-content">
    <app-svg-delivery-error></app-svg-delivery-error>
    <h3>{{ 'CHECKOUT.ADDRESS_VALIDATION.TITLE' | translate }}</h3>
  </div>
  <div class="validation-details">
    {{ region | translate }} - {{ postalCode }}
  </div>
  <p class="secondary-content">
    {{ 'CHECKOUT.ADDRESS_VALIDATION.MESSAGE' | translate }}
  </p>
  <div class="actions">
    <button class="action-btn" mm-button color="secondary" (click)="onChangeAddress()">
      {{ 'CHECKOUT.ADDRESS_VALIDATION.ACTIONS.CHANGE_ADDRESS' | translate }}
    </button>
    <button class="action-btn" mm-button (click)="onChangeOrder()">
      {{ 'CHECKOUT.ADDRESS_VALIDATION.ACTIONS.CHANGE_ORDER' | translate }}
    </button>
  </div>
</div>
